import  * as actionTypes from './actions';
import { AxiosError } from 'axios';


type State = {
  loading: boolean;
  data: {[key:string]:any} | null;
  error: AxiosError | null;
  // length: number | null;
  getData:{[key:string]:any} | null;
};

const initiaState = {
  loading: false,
  data: null,
  error: null,
  // length: null,
  getData:null
};

export default function products(
  state: State = initiaState,
  action: actionTypes.GetProductsActionsType
): State {
  switch (action.type) {
    case actionTypes.PRODUCT_PAGE_INIT:
      return {
        ...state,
        loading: true,
        data:null,
        error:null
      };
    case actionTypes.PRODUCT_SUCCESS:
      const result = action.payload;
      return {
        ...state,
        loading: false,
        data: result,
        error:null,
        // length: result.length
      };
    case actionTypes.PRODUCT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error
      };
      case actionTypes.PRODUCT_ID_INIT:
      return {
        ...state,
        loading: true,
        data:null,
        error:null
      };
    case actionTypes.PRODUCT_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        error:null,
        getData: action.payload,
      }
    case actionTypes.PRODUCT_ID_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error
      }
      case actionTypes.PRODUCT_CREATE_INIT:
        return {
          ...state,
          loading: true,
          data:null,
          error:null
        }
      case actionTypes.DISPLAY_MORE_BEGIN:
			return {
				...state,
				loading: true,
				data:null,
        error:null
			};
		case actionTypes.DISPLAY_MORE_END:
			return {
				...state,
				loading: false,
				error:null,
			};
      case actionTypes.PRODUCT_CREATE_SUCCESS:
        return {
          ...state,
          loading: false,
          error:null,
          data: action.payload
          
        }
      case actionTypes.PRODUCT_CREATE_ERROR:
        return {
          ...state,
          loading: false,
          error: action.error
        }   
    case actionTypes.PRODUCT_UPDATE_INIT:
      return {
        ...state,
        loading: true,
        data:null,
        error:null
        
      }
    case actionTypes.PRODUCT_UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        error:null,
        data: action.payload
      }
    case actionTypes.PRODUCT_UPDATE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error
      }
      case actionTypes.PRODUCT_DELETE_INIT:
        return {
          ...state,
          loading: true,
          data:null,
          error:null
        }  
    case actionTypes.PRODUCT_DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        error:null,
        data: action.payload
      }
    case actionTypes.PRODUCT_DELETE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error
      }
    default:
      return state;
  }
}
